export var PhoneType;
(function (PhoneType) {
    PhoneType["MOBILE"] = "MOBILE";
    PhoneType["TELEPHONE"] = "TELEPHONE";
    PhoneType["FAX"] = "FAX";
    PhoneType["OTHER"] = "OTHER";
})(PhoneType || (PhoneType = {}));
export var PhoneLocationType;
(function (PhoneLocationType) {
    PhoneLocationType["BRAND_RES_OFFICE"] = "BRAND_RES_OFFICE";
    PhoneLocationType["CENTER_RES_OFFICE"] = "CENTER_RES_OFFICE";
    PhoneLocationType["PROPERTY_RES_OFFICE"] = "PROPERTY_RES_OFFICE";
    PhoneLocationType["PROPERTY_DIRECT"] = "PROPERTY_DIRECT";
    PhoneLocationType["SALES_OFFICE"] = "SALES_OFFICE";
    PhoneLocationType["HOME"] = "HOME";
    PhoneLocationType["OFFICE"] = "OFFICE";
    PhoneLocationType["OTHER"] = "OTHER";
    PhoneLocationType["MANAGING_COMPANY"] = "MANAGING_COMPANY";
    PhoneLocationType["MOBILE"] = "MOBILE";
})(PhoneLocationType || (PhoneLocationType = {}));
